'use client';

import { c as _c } from "react/compiler-runtime";
import type { AnswerValue } from '@repo/contracts/cardfinder/funnel/types';
import { useIdentityContext } from '@repo/platform-analytics/IdentityContext';
import { type FunnelSessionUpdate, useFunnelSession } from '@/entities/session/model/funnel-session-context';
import type { FunnelSession } from '@/entities/session/model/types';
import { isFunnelComplete } from '@/shared/config/funnel/completion';
import { useFunnelConfigVersion, useFunnelFlattenedConfig } from '../Context/hooks';
import { funnelSessionReducer } from '../session/funnel-session-reducer';
import { isPastFirstQuestion } from './utils/is-past-first-question';
export function useFunnelProgression() {
  const $ = _c(18);
  const {
    session,
    commit,
    saveToApi
  } = useFunnelSession();
  const funnelFlattenedConfig = useFunnelFlattenedConfig();
  const funnelConfigVersion = useFunnelConfigVersion();
  const {
    isLoggedIn
  } = useIdentityContext();
  let t0;
  if ($[0] !== commit || $[1] !== funnelFlattenedConfig || $[2] !== session) {
    t0 = (stepId, value) => {
      const isFinished = session.status === "complete" && isFunnelComplete(funnelFlattenedConfig, session.answers);
      const base = isFinished ? funnelSessionReducer(session, {
        type: "startNewSession"
      }) : session;
      const next = funnelSessionReducer(base, {
        type: "record",
        stepId,
        value
      });
      commit(next);
      return next;
    };
    $[0] = commit;
    $[1] = funnelFlattenedConfig;
    $[2] = session;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const recordAnswer = t0;
  let t1;
  if ($[4] !== funnelConfigVersion || $[5] !== isLoggedIn || $[6] !== recordAnswer || $[7] !== saveToApi) {
    t1 = async (stepId_0, value_0) => {
      const next_0 = recordAnswer(stepId_0, value_0);
      if (!isLoggedIn || !isPastFirstQuestion(next_0.answers)) {
        return {
          kind: "continue",
          session: next_0
        };
      }
      return saveToApi(next_0, funnelConfigVersion);
    };
    $[4] = funnelConfigVersion;
    $[5] = isLoggedIn;
    $[6] = recordAnswer;
    $[7] = saveToApi;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const answerStep = t1;
  let t2;
  if ($[9] !== commit || $[10] !== funnelConfigVersion || $[11] !== funnelFlattenedConfig || $[12] !== saveToApi) {
    t2 = async target => {
      if (!isFunnelComplete(funnelFlattenedConfig, target.answers)) {
        return {
          kind: "continue",
          session: target
        };
      }
      const next_1 = funnelSessionReducer(target, {
        type: "complete"
      });
      commit(next_1);
      return saveToApi(next_1, funnelConfigVersion);
    };
    $[9] = commit;
    $[10] = funnelConfigVersion;
    $[11] = funnelFlattenedConfig;
    $[12] = saveToApi;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  const finish = t2;
  let t3;
  if ($[14] !== answerStep || $[15] !== finish || $[16] !== recordAnswer) {
    t3 = {
      answerStep,
      recordAnswer,
      finish
    };
    $[14] = answerStep;
    $[15] = finish;
    $[16] = recordAnswer;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  return t3;
}